<template>
  <div>
    <v-row class="mb-5 mt-0">
      <v-col class="py-0" lg="3" cols="6">
        <OrderCard title="Cliente" icon="mdi-account" color="#8bc34a">
          <h2 cass="my-0 mx-5">{{ order.clientFirstName + ' ' + order.clientLastName }}</h2>
          <div v-if="order.clientDocumentType" class="mb-2">
            {{ order.clientDocumentType | uppercase }}:
            {{ order.clientDocument | formatCPF }}
          </div>
          <div cass="mb-2" v-if="order.orderSellerStatus > 2">
            <b>Contato</b><br />
            <span v-if="order.customerEmail"><v-icon small>mdi-email</v-icon> {{ order.customerEmail }} <br /></span>
            <v-icon small>mdi-phone</v-icon>
            {{ order.clientPhone | formatPhone }}
          </div>
        </OrderCard>
      </v-col>
      <v-col class="py-0" lg="3" cols="6">
        <OrderCard title="Status do Pedido" icon="mdi-relative-scale" color="#8bc34a">
          <center>
            <div class="noprint">
              <v-chip label :color="getColor(order.orderStatus)" dark class="ma-1">{{
                order.orderStatusDescription
              }}</v-chip>
              <v-chip label :color="getColor(order.orderSellerStatus)" dark class="ma-1">{{
                getStatusSeller(order.orderSellerStatus)
              }}</v-chip>
              <br />
            </div>
            <i>Criado em {{ order.orderCreationDate | formatFullDate }}</i>
            <br />
            <i v-if="order.orderLastChange">
              Última atualização em
              {{ order.orderLastChange | formatFullDate }}
            </i>
          </center>
        </OrderCard>
      </v-col>
      <v-col class="noprint py-0" lg="3" cols="6">
        <OrderCard title="Informações do Seller" icon="mdi-shopping" color="#8bc34a">
          <center>
            Vendido por
            <h2>
              <b v-for="seller in order.sellers" :key="seller.sellerId">
                {{ seller.sellerDescription }}
              </b>
            </h2>
          </center>
        </OrderCard>
      </v-col>
      <v-col class="py-0" lg="3" cols="6">
        <OrderCard title="Valor Total" icon="mdi-cash-usd" color="#8bc34a">
          <center>
            <h1>{{ order.orderValue | formatFullMoney }}</h1>
            <div v-for="transaction in order.transactions" :key="transaction.transactionId">
              <div v-for="(payment, i) in transaction.payments" :key="i">
                <h4 class="sub-2">
                  <i> {{ payment.paymentInstallments }} x </i>
                  {{ transaction.payments[0].paymentSystemName }}
                </h4>
              </div>
            </div>
            <div v-if="order.orderNfe"><b>NFE:</b> {{ order.orderNfe }}</div>
          </center>
        </OrderCard>
      </v-col>
    </v-row>

    <v-row class="mb-5 mt-0">
      <v-col lg="9" md="12" cols="12" class="py-0">
        <OrderCard title="Produtos" icon="mdi-inbox-arrow-down" color="#ff9800">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left noprint"></th>
                  <th class="text-left">
                    Produto
                  </th>
                  <th class="text-left">
                    Quantidade
                  </th>
                  <th class="text-left">
                    Valor Frete
                  </th>
                  <th class="text-left">
                    Valor Unitário
                  </th>
                  <th class="text-left">
                    Valor Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, i) in order.products" :key="i">
                  <td class="">
                    <v-img :src="product.productImageUrl" aspect-ratio="1" width="80px" class="grey lighten-2"></v-img>
                  </td>
                  <td class="py-2">
                    <div class="hl">
                      <h3>
                        {{ product.productName }}
                        <span v-if="product.productName !== product.skuName"> ({{ product.skuName }}) </span>
                        <TheToolTip label="Produto Loja">
                          <a :href="'https://loja.wap.ind.br' + product.url" v-if="product.url" target="_BLANK">
                            <v-icon small> mdi-link-variant </v-icon>
                          </a>
                        </TheToolTip>
                      </h3>
                    </div>
                    <div class="sub"><b>EAN</b>: {{ product.productEan }}</div>
                    <div class="sub"><b>Sku ID</b>: {{ product.skuId[0] }}</div>
                    <div class="sub" v-if="product.referenceId"><b> Ref:</b>: {{ product.referenceId }}</div>
                    <div class="sub" v-if="product.sellerProductSku">
                      <b>Sku Seller</b>: {{ product.sellerProductSku }}
                    </div>
                    <div class="sub" v-if="product.sellerProductDescription">
                      <b>Nome Seller</b>:
                      {{ product.sellerProductDescription }}
                    </div>
                  </td>
                  <td class="text-right">
                    {{ product.orderProductAmount }}
                  </td>
                  <td class="text-right">
                    <div v-if="order.logistic[i]">
                      {{ order.logistic[i].logisticPrice | formatFullMoney }}
                    </div>
                  </td>
                  <td class="text-right">
                    {{
                      getProductPrice(product.orderProductSellingPrice, product.orderProductAmount, order.logistic[i])
                        | formatFullMoney
                    }}
                  </td>
                  <td class="text-right">
                    {{ getProductPrice(product.orderProductSellingPrice, 0, order.logistic[i]) | formatFullMoney }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="border-top:1px solid #dedede;">
                  <td class="noprint"></td>
                  <td colspan="2"></td>
                  <td class="text-right pt-2">
                    <b>Valor Frete </b><br />
                    {{ order.logisticTotal | formatFullMoney }}
                  </td>
                  <td></td>
                  <td class="text-right pt-2">
                    <b>Valor Total </b><br />
                    {{ order.orderValue | formatFullMoney }}
                  </td>
                </tr>
              </tfoot>
            </template>
          </v-simple-table>
        </OrderCard>
      </v-col>
      <v-col lg="3" md="12" cols="12" class="py-0" v-if="order.transactions">
        <OrderCard title="Entrega" icon="mdi-city" color="#ff9800" v-if="order.address">
          <h3 class="sub-2"><b>Destinatário:</b> {{ order.address.addressReceiverName }}</h3>
          <b>Endereço:</b>
          {{ order.address.addressStreet }}, {{ order.address.addressNumber }}<br />
          <b> Cep: </b> {{ order.address.addressPostalCode }}<br />
          <div v-if="order.address.addressComplement">
            <b>Complemento:</b>
            <br />
            {{ order.address.addressComplement }} <br />
          </div>
          <b>Bairro:</b>
          {{ order.address.addressNeighborhood }} <br />
          <b>Cidade: </b>
          {{ order.address.addressCity }} <br />
          <b>Estado:</b>
          {{ order.address.addressState }}

          <div v-if="order.orderCarrier"><b>Transportadora:</b> {{ order.orderCarrier }}</div>
          <div v-if="order.orderTracking"><b>Tracking:</b> {{ order.orderTracking }}</div>
          <div v-if="order.orderTrackingUrl"><b>Url:</b> {{ order.orderTrackingUrl }}</div>

          <div v-if="order.orderAuthorizedDate && addBusinessDays(order.orderAuthorizedDate, 2) !== 'Invalid Date'">
            <b>Despachar até:</b>
            {{ addBusinessDays(order.orderAuthorizedDate, order.logisticShippingEstimate) }}
            <!-- Adicionar tempo base seller -->
          </div>
          <div v-if="order.orderAuthorizedDate && order.logisticShippingEstimate">
            <b>Entregar até:</b>
            {{ addBusinessDays(order.orderAuthorizedDate, order.logisticShippingEstimate) }}
          </div>
        </OrderCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrderCard from '@/components/OrderCard'
import TheToolTip from '@/components/TheToolTip'
import { getColor, getStatusSeller, back, addBusinessDays } from '@/plugins/generic.js'

export default {
  data: () => ({
    logisticTotal: 0
  }),
  props: {
    order: Object,
  },
  components: {
    OrderCard,
    TheToolTip,
  },
  methods: {
    getColor,
    getStatusSeller,
    addBusinessDays,
    getProductPrice(price, amount, logistic) {
      let priceR = price + (logistic.logisticListPrice - logistic.logisticPrice)
      if (amount) {
        priceR /= amount
      }
      return priceR
    },
  },
}
</script>

<style></style>
